
<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-button type="primary" size="small" class="newBtn" @click="batchRetryEmail(1)">SMTP批量重推</el-button>
        <el-button type="primary" size="small" class="newBtn" @click="batchRetryEmail(2)">邮件服务批量重推</el-button>
      </el-col>
    </el-row>
    <el-table class="myTable" :data="tableData" @selection-change="handleSelectionChange" :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="vendorId" label="店铺ID"></el-table-column>
      <el-table-column prop="orderLineNum" label="订单号"> </el-table-column>
      <el-table-column prop="addressTo" label="收件地址"></el-table-column>
      <el-table-column prop="status" label="发信状态">
        <template slot-scope="scope">
          <!-- 发信状态 -1:异常 0:正常 1:待发送 -->
          <div v-if="scope.row.status ==-1"><span>异常</span></div>
          <div v-else-if="scope.row.status ==0"><span>正常</span></div>
          <div v-else><span>待发送</span></div>
        </template>
      </el-table-column>
      <el-table-column prop="sendMethod" label="发信方式">
        <!-- 1-smtp,2-邮件服务 -->
        <template slot-scope="scope">
          <div v-if="scope.row.sendMethod ==1"><span>SMTP</span></div>
          <div v-else><span>邮件服务</span></div>
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" label="推送时间"></el-table-column>
      <el-table-column prop="retryCount" label="推送次数"></el-table-column>
      <el-table-column prop="reason" label="失败内容"></el-table-column>
      <el-table-column prop="createdAt" label="订单创建时间"></el-table-column>
    </el-table>
    <el-pagination class="pagePos" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[15, 25, 30, 50]" :page-size="pageSize" layout="total, prev, pager, next,sizes, jumper" :total="total"></el-pagination>
  </div>
</template>
<script>
import { pageEmailSendRecord, batchRetryEmail } from "./api.js";
export default {
  data() {
    return {
      currentPage: 1,
      pageSize: 15,
      total: 0,
      form: {},
      multipleSelection: [],
      tableData: []
    };
  },
  methods: {
    handleSelectionChange(val) { this.multipleSelection = val.map(item => { return item.emailStatusId }); },
    resetForm() {
      this.form = {};
    },
    async batchRetryEmail(num) {
      if (!this.multipleSelection.length) { this.$message.error('请选择'); return; }
      try {
        this.$store.commit("setPageLoading", true);
        let resData = await batchRetryEmail({ emailStatusIds: this.multipleSelection, sendMethod: num });
        console.log(resData);
        if (!resData) {
          this.$store.commit("setPageLoading", false);
          this.$message.error(`${resData.message || resData.data}`); return;
        }
        this.$message.success('批量重推成功');
        this.getTableData(this.form);
        this.$store.commit("setPageLoading", false);
      } catch (error) {
        this.$message.error('接口异常')
        this.$store.commit("setPageLoading", false);
      }
    },
    refresh() {
      this.getTableData(this.form)
    },
    async getTableData(data) {
      try {
        if (data.isReset) {
          this.currentPage = 1;
        }
        let targetObj = {
          pageSize: this.pageSize,
          pageNum: this.currentPage
        };
        Object.assign(targetObj, this.form, data);
        this.$store.commit("setPageLoading", true);
        let resData = (await pageEmailSendRecord(targetObj)).data;
        if (!resData) {
          this.$store.commit("setPageLoading", false);
          this.$message.error('接口异常')
        }
        data.isReset = false;
        this.form = data;
        let { pageSize, pageNum, totalCount, list } = resData;
        this.pageSize = pageSize;
        this.currentPage = pageNum;
        this.total = totalCount;
        this.tableData = list;
        this.$store.commit("setPageLoading", false);
      } catch (error) {
        this.$message.error('接口异常')
        this.$store.commit("setPageLoading", false);
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getTableData(this.form);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableData(this.form);
    }
  }
};
</script>
<style lang="less" scoped>
.pagePos {
  margin-top: 20px;
  position: absolute;
  right: 280px;
  height: 80px;
}
.manipulate {
  margin-right: 12px;
  color: #409eff;
  cursor: pointer;
}
.dot {
  display: inline-block;
  margin-right: 8px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.gray {
  background: #cccccc;
}
.green {
  background: green;
}
.red {
  background: red;
}
.yellow {
  background: yellow;
}
</style>
<style lang="less">
.myTable {
  thead th {
    color: #000;
  }
}
</style>